import BackupExportPanel from '@/components/BackupExportPanel';
import BackupRestoreDialog from '@/components/BackupRestoreDialog';

export default function BackupRestorePanel() {
  return (
    <div className="space-y-5" data-testid="backup-restore-panel">
      <BackupExportPanel />
      <BackupRestoreDialog />
    </div>
  );
}
